import ajax from "plugins/AjaxService"
import { Consumption, ConsumptionByCrop } from "types/Consumption"
import { DateRange } from "types/global"
import { dateRangeToDateRangeString } from "utils"


/**
 * INDEX
 * Collect all PowerConsumption of a specific FARM in a range
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-63475
 */
function index(farmId: number, range?: DateRange): Promise<{ data: Consumption[] }> {
	const r = dateRangeToDateRangeString(range)
	const query = !!r ? `start_due_date=${r.start}&end_date=${r.end}` : ""
	return ajax.get(`farms/${farmId}/consumptions?${query}`)
}

/**
 * BY CROP LOT
 * Collect all PowerConsumption by crop_lot of a specific FARM in a range
 * https://app.clickup.com/30373227/docs/wyxbb-20075/wyxbb-63755
 */
function byCrop(farmId: number, range?: DateRange): Promise<{ data: ConsumptionByCrop }> {
	const r = dateRangeToDateRangeString(range)
	return ajax.get(
		`farms/${farmId}/consumptions/by_crop_lot?start_date=${r?.start}&end_date=${r?.end}`,
		undefined,
		{ noCamelize: true }
	)
}


const consumptionApi = {
	index,
	byCrop,
}

export default consumptionApi
